export const buildOption = responsibility => ({
  value: responsibility,
  label: responsibility,
})

export const buildResponsibility = option => option.value
